import dayjs from 'dayjs'
import { DATE_FORMAT, TRADE_BLOTTER_STATUS } from '../../../utils/constants'
import { changeUtcTimeToLocal } from '../../../helper'

class TradeForm {
  constructor(data) {
    const currencyInitial = { id: 0, name: '', code3: '', is_ndf: '' }
    const tradeTypeInitial = { id: 0, name: '', deal_type_group: '' }
    this.trade_type = data.type ?? tradeTypeInitial
    this.side = ''
    if (this.trade_type.name.includes('Client') && data.side) {
      this.side = data.side === 'BUY' ? 'SELL' : 'BUY'
    } else {
      this.side = data.side
    }
    this.bdr = data.bdr || ''
    this.is_pba = !!data.is_pba || false
    this.is_structure = !!data.is_structure || false
    this.cut = data.cut ?? ''
    this.base_currency = data.base_currency ?? ''
    this.counter_currency = data.counter_currency ?? ''
    this.currency_pair =
      data.base_currency !== undefined ? data.base_currency.concat(data.counter_currency) : ''
    this.quantity = Math.abs(data.client_quantity) || Math.abs(data.market_maker_quantity) || ''
    this.price = data.client_price || data.market_maker_price || ''
    this.trade_date = data.trade_date
      ? changeUtcTimeToLocal(data.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
      : dayjs().format(DATE_FORMAT.REGULAR_DATE_TIME)
    this.value_date = data.value_date ? dayjs(data.value_date).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.counterparty = data.client || data.market_maker || ''
    this.put_call = data.put_call || ''
    this.strike = data.strike || ''
    this.trader_name = data.trader_name ?? ''
    this.expiry = data.expiry ? dayjs(data.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.settlement_date = data.settlement_date
      ? dayjs(data.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''

    this.fixing_source = data.fixing_source ?? ''

    this.fixing_date = data.fixing_date
      ? dayjs(data.fixing_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.note = data.note || ''
    this.premium_amount = data.premium_amount || ''
    this.premium_date = data.premium_date
      ? dayjs(data.premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.is_conversion = data.status === TRADE_BLOTTER_STATUS.CONVERSION
    this.premium_currency = data.premium_currency ?? currencyInitial
    this.payout_currency = data.payout_currency || currencyInitial
    this.payout_amount = data.payout_amount || ''
    this.spot_ref = data.spot_ref || ''
    this.timing = data.timing || ''
    this.barrier = data.barrier || ''
    this.lower_barrier = data.lower_barrier || ''
    this.upper_barrier = data.upper_barrier || ''
    this.window_start = data.window_start
      ? dayjs(data.window_start).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.window_end = data.window_end ? dayjs(data.window_end).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.far_price = data.far_price || ''
    this.far_value_date = data.far_value_date
      ? dayjs(data.far_value_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.far_leg_quantity = Math.abs(data.far_leg_quantity) || ''
    this.far_fixing_date = data.far_fixing_date
      ? dayjs(data.far_fixing_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.trade_origin = data.trade_origin ?? 'FXER'
    if (data.direction) {
      this.direction = data.direction
    }
  }
}

export default TradeForm
